import { UPLOAD_MAX_BYTES_HOMEPAGE } from "@/lib/upload-constants"
import { analysisFunnelEnvelope, trackEvent } from "@/lib/analytics"
import type { AnalysisFunnelMode } from "@/lib/analysis-funnel-envelope"

export type UploadPrecheckReason =
  | "file_too_large"
  | "invalid_file_type"
  | "too_many_files"
  | "other"

const MAX_MB = Math.round(UPLOAD_MAX_BYTES_HOMEPAGE / (1024 * 1024))

export const UPLOAD_REJECTION_COPY: Record<UploadPrecheckReason, string> = {
  file_too_large: `That photo is too large. Try one under ${MAX_MB} MB.`,
  invalid_file_type: "That file type is not supported. Use a JPG, PNG, WebP, or HEIC photo.",
  too_many_files: "Add one photo at a time.",
  other: "That photo could not be used. Try another one.",
}

/** Maps a react-dropzone rejection error code to a precheck reason. */
export function uploadReasonFromDropzoneCode(code: string | undefined): UploadPrecheckReason {
  switch (code) {
    case "file-too-large":
      return "file_too_large"
    case "file-invalid-type":
      return "invalid_file_type"
    case "too-many-files":
      return "too_many_files"
    default:
      return "other"
  }
}

/**
 * Fires `grass_id_upload_rejected` for a file refused before any upload
 * starts, so these never pair with a `grass_id_upload_started`.
 */
export function trackUploadPrecheckRejected(props: {
  reason: UploadPrecheckReason
  capturePath: "file" | "drop" | "camera" | "unknown"
  mode: AnalysisFunnelMode
  funnelId?: string | null
  fileSizeBytes?: number
}): void {
  trackEvent("grass_id_upload_rejected", {
    ...analysisFunnelEnvelope({
      funnelId: props.funnelId,
      mode: props.mode,
      source: props.capturePath,
      imageRoles: ["primary"],
      actualDestination: "upload_error",
    }),
    reason: props.reason,
    stage: "client_precheck",
    capture_path: props.capturePath,
    source: props.capturePath,
    mode: props.mode,
    ...(typeof props.fileSizeBytes === "number"
      ? { file_size_kb: Math.round(props.fileSizeBytes / 1024) }
      : {}),
  })
}
